import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateTaxSettings, TaxSettings } from '../../../api/TaxSettings/taxSettings';

export function useUpdateTaxSettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (taxSettings: TaxSettings) => updateTaxSettings(taxSettings),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ 'getTaxSettings' ] });
    },
  });
}
